import api from '@/services/api'
import { dateNowUsOneYearAgo } from '@/utils/date'

export default {
  state: {
    contracts: {
      data: [],
      filters: {
        onlyActive: true,
        startDate: dateNowUsOneYearAgo(),
        searchDataTable: '',
      },
    },
  },

  mutations: {
    SET_CONTRACTS(state, contracts) {
      state.contracts = contracts
    },
  },

  actions: {
    // Listagem de contratos
    async getContracts({ commit }, filters) {
      try {
        const response = await api.get(
          `/documents/contracts?startDate=${filters.startDate}&onlyActive=${filters.onlyActive}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    // Detalhes do contrato
    async getContract({ commit }, idContract) {
      try {
        const response = await api.get(`/documents/contracts/${idContract}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    // Aditivos do contrato
    async getAdditives({ commit }, data) {
      try {
        const response = await api.get(
          `/documents/contracts/${data.idContract}/additives?startDate=${data.startDate}&endDate=${data.endDate}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    // Faturamentos do contrato
    async getRevenues({ commit }, idContract) {
      try {
        const response = await api.get(
          `/documents/contracts/${idContract}/revenues`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    // Itens do contrato
    async getContractItens({ commit }, idContract) {
      try {
        const response = await api.get(
          `/documents/contracts/${idContract}/itens`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    // Salva uma medição do contrato
    async saveContractMeasure({ commit }, data) {
      try {
        return await api.post(
          `/documents/contracts/${data.get('contractId')}/measures`,
          data,
        )
      } catch (error) {
        throw error
      }
    },

    // Lista medições do contrato
    async getContractMeasures({ commit }, idContract) {
      try {
        const response = await api.get(
          `/documents/contracts/${idContract}/measures`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    // Atualiza medição do contrato
    async updateContractMeasure({ commit }, data) {
      try {
        return await api.put(
          `/documents/contracts/${data.idContract}/measures/${data.measureId}`,
          data,
        )
      } catch (error) {
        throw error
      }
    },

    // Certidões do Seven (tecnico)
    async getAtegPcTecInfo({ commit }, data) {
      try {
        const response = await api.get(
          `/documents/contracts/${data.contractId}/ateg-pctec-info/${data.ategPcTecId}`,
        )

        return response && response.status ? response.data : false
      } catch (error) {
        throw error
      }
    },

    // Lista certidões do Seven (supervisor)
    async getAtegPcSupList({ commit }, contractId) {
      try {
        const response = await api.get(
          `/documents/contracts/${contractId}/ateg-pcsup-list`,
        )

        return response && response.status ? response.data : false
      } catch (error) {
        throw error
      }
    },

    // Certidões do Seven (supervisor)
    async getAtegPcSupInfo({ commit }, data) {
      try {
        const response = await api.get(
          `/documents/contracts/${data.contractId}/ateg-pcsup-info/${data.ategPcSupNfCodRateio}`,
        )

        return response && response.status ? response.data : false
      } catch (error) {
        throw error
      }
    },

    setContracts({ commit }, data) {
      commit('SET_CONTRACTS', data)
    },

    resetContracts({ commit }) {
      const contracts = {
        data: [],
        filters: {
          onlyActive: true,
          startDate: dateNowUsOneYearAgo(),
          searchDataTable: '',
        },
      }
      commit('SET_CONTRACTS', contracts)
    },
  },

  getters: {
    contracts: (state) => state.contracts,
  },
}
